import { useState } from "react";
import { useAdminExperiences } from "@/hooks/useAdminExperiences";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { AdminExperienceCard } from "@/components/AdminExperienceCard";

const statuses = [
  { value: "", label: "All" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "NEEDS_HUMAN_REVIEW", label: "Needs Review" },
];

export function ExperiencesPage() {
  useDocumentTitle("Experiences");
  const [status, setStatus] = useState("");
  const { data: experiences, isLoading, error } = useAdminExperiences(status || undefined);

  return (
    <div>
      <h1 className="font-headline-lg text-headline-lg text-on-surface mb-stack-md">
        Experiences
      </h1>

      {/* Status filter tabs */}
      <div className="flex gap-2 mb-stack-md">
        {statuses.map((s) => (
          <button
            key={s.value}
            onClick={() => setStatus(s.value)}
            className={`px-3 py-1.5 rounded-lg font-label-sm text-label-sm transition-colors ${
              status === s.value
                ? "bg-primary-container text-on-primary-container"
                : "bg-surface-container-high text-on-surface-variant hover:text-on-surface"
            }`}
          >
            {s.label}
          </button>
        ))}
      </div>

      {isLoading && (
        <p className="font-body-md text-on-surface-variant">Loading experiences...</p>
      )}

      {error && (
        <p className="font-body-md text-error">Failed to load experiences.</p>
      )}

      {experiences && experiences.length === 0 && (
        <p className="font-body-md text-on-surface-variant">No experiences found.</p>
      )}

      {experiences && experiences.length > 0 && (
        <div className="space-y-stack-sm">
          {experiences.map((exp) => (
            <AdminExperienceCard key={exp.id} experience={exp} />
          ))}
        </div>
      )}
    </div>
  );
}
